module.exports = __webpack_public_path__ + "img/about-11.e643c61c.png";